/** @format */

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const CLOUDFLARE_RESIZE_SERVICE_PATH = '/media-service-img-cdn/';

/**
 * This is the default quality used by the Cloudflare resizing service
 *
 * This is configured globally because additional quality variants incurs a cost to the service
 */
// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const CLOUDFLARE_IMAGE_QUALITY = 90;

/**
 * List of sizes available from the Cloudflare resizing service
 *
 * Increasing the number of options here will INCREASE THE COST OF THE SERVICE as we are charged per variant.
 *
 * @format
 */
// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum CloudflareImageSize {
    THUMBNAIL = 286,
}
